import api from '@/services/base.service'

const methods = {
  getZonas(zonaId) {
    return api.get(`/ubicaciones/zonas`, {
      params: { zonaId }
    })
  },
  getPasillos(bodegaId, zonaId, zonaPBEId) {
    return api.get(`/ubicaciones/pasillos`, {
      params: { bodegaId, zonaId, zonaPBEId }
    })
  },
  getNiveles(zonaId, pasilloPBEId) {
    return api.get(`/ubicaciones/niveles`, {
      params: { zonaId, pasilloPBEId }
    })
  },
  getUbicaciones(bodegaId, zonaId, zonaPBEId, pasilloPBEId, nivelPBEId) {
    return api.get(`/ubicaciones`, {
      params: { bodegaId, zonaId, zonaPBEId, pasilloPBEId, nivelPBEId }
    })
  },
  updateUbicaciones(zonaId) {
    return api.post(`/ubicaciones/${zonaId}`)
  }
}

export default methods
